import {Component, Input, Optional, ViewEncapsulation} from "@angular/core";
import {Home365Constants} from "@home365/common-classes";

export type ModalSize = 's' | 'm' | 'l' | 'xl' | 'xxl';

export class Home365LoaderOptions {
  constructor(public size?: ModalSize) {
  }
}

@Component({
  selector: "lib-home365-loader",
  templateUrl: "./home365-loader.component.html",
  styleUrls: ["./home365-loader.component.css"],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    class: 'lib-home365-loader'
  }
})
export class Home365LoaderComponent {
  // @deprecated - Use size instead
  diameter!: number;
  @Input() white!: boolean;

  /**
   * @param value - default is 'm'
   */
  @Input() set size(value: ModalSize) {
    switch (value) {
      case 's':
        this.diameter = Home365Constants.marginUnit * 2;
        break;
      case 'm':
        this.diameter = Home365Constants.marginUnit * 3;
        break;
      case 'l':
        this.diameter = Home365Constants.marginUnit * 6;
        break;
      case 'xl':
        this.diameter = Home365Constants.marginUnit * 8;
        break;
      case 'xxl':
        this.diameter = Home365Constants.marginUnit * 10;
        break;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(@Optional() options: Home365LoaderOptions) {
    this.size = options?.size ?? 'm';
  }
}
